import { has, set } from 'lodash-es'
import { REQUEST_STATE, SET_STATE_KEY } from './constants'

export const CONSTANT_TYPES = {
  SET_CONNECTION_STATE: 'SET_CONNECTION_STATE',
}

export const getTypes = stateSets =>
  stateSets.reduce((types, type) => ({ ...types, [type]: type }), CONSTANT_TYPES)

export const getMutations = stateSets => {
  return stateSets.reduce((mutations, stateSet) => {
    mutations[stateSet.type] = (state, payload) => {
      switch (payload.type) {
        case REQUEST_STATE.STATE_PENDING: {
          set(state[`${SET_STATE_KEY}_${stateSet.type}`], stateSet.stateKey, payload.type)
          set(state[`${SET_STATE_KEY}_${stateSet.type}`], stateSet.modifiedKey, new Date())
          if (has(payload, 'data')) {
            set(state[`${SET_STATE_KEY}_${stateSet.type}`], stateSet.dataKey, payload.data)
          }
          if (stateSet.cancelSource && has(payload, 'cancelSource')) {
            set(
              state[`${SET_STATE_KEY}_${stateSet.type}`],
              stateSet.cancelSource,
              payload.cancelSource,
            )
          }
          if (stateSet.promise && has(payload, 'promise')) {
            set(state[`${SET_STATE_KEY}_${stateSet.type}`], stateSet.promise, payload.promise)
          }
          return
        }
        case REQUEST_STATE.STATE_SUCCESS:
          set(state[`${SET_STATE_KEY}_${stateSet.type}`], stateSet.stateKey, payload.type)
          set(state[`${SET_STATE_KEY}_${stateSet.type}`], stateSet.modifiedKey, new Date())
          set(state[`${SET_STATE_KEY}_${stateSet.type}`], stateSet.dataKey, payload.data)
          set(state[`${SET_STATE_KEY}_${stateSet.type}`], stateSet.statusCodeKey, payload.status)
          set(state[`${SET_STATE_KEY}_${stateSet.type}`], stateSet.messageKey, null)
          if (stateSet.cancelSource) {
            set(state[`${SET_STATE_KEY}_${stateSet.type}`], stateSet.cancelSource, null)
          }
          return
        case REQUEST_STATE.STATE_FAILURE:
          set(state[`${SET_STATE_KEY}_${stateSet.type}`], stateSet.stateKey, payload.type)
          set(state[`${SET_STATE_KEY}_${stateSet.type}`], stateSet.modifiedKey, new Date())
          set(state[`${SET_STATE_KEY}_${stateSet.type}`], stateSet.messageKey, payload.errorMessage)
          set(state[`${SET_STATE_KEY}_${stateSet.type}`], stateSet.statusCodeKey, payload.status)
          set(state[`${SET_STATE_KEY}_${stateSet.type}`], stateSet.dataKey, payload.data)
          if (stateSet.cancelSource) {
            set(state[`${SET_STATE_KEY}_${stateSet.type}`], stateSet.cancelSource, null)
          }
          return
        case REQUEST_STATE.STATE_INITIAL:
          set(state[`${SET_STATE_KEY}_${stateSet.type}`], stateSet.stateKey, payload.type)
          set(state[`${SET_STATE_KEY}_${stateSet.type}`], stateSet.modifiedKey, new Date())
          set(state[`${SET_STATE_KEY}_${stateSet.type}`], stateSet.messageKey, null)
          set(state[`${SET_STATE_KEY}_${stateSet.type}`], stateSet.statusCodeKey, null)
          set(state[`${SET_STATE_KEY}_${stateSet.type}`], stateSet.dataKey, null)
          if (stateSet.cancelSource) {
            set(state[`${SET_STATE_KEY}_${stateSet.type}`], stateSet.cancelSource, null)
          }
      }
    }
    return mutations
  }, {})
}
